module.exports = __webpack_public_path__ + "img/img_banner_index_05.ee36e88f.jpg";